import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Editor from './TextEditor/Editor';
import PostContent from './PostContent';

// `siblings` is the already-sorted, already-filtered list of posts the
// caller is rendering `post` within — reorder arrows move `post` relative
// to that exact list, and are hidden at the ends of it.
const PostCard = ({ post, siblings, currentUser, dispatchPosts, socket }) => {

    const canEdit = currentUser.isAuthenticated && currentUser.user.isAdmin > 9 && currentUser.adminSettings;

    const index = siblings.findIndex(s => s._id === post._id);
    const canMoveUp = index > 0;
    const canMoveDown = index > -1 && index < siblings.length - 1;

    const swapOrder = (other) => {
        const payloadFor = (target, order) => ({
            id: currentUser.user._id,
            jwt: currentUser.user.jwt,
            newPost: { ...target, order },
        });

        socket.emit('update post', payloadFor(post, other.order));
        socket.emit('update post', payloadFor(other, post.order));
        socket.on('post updated', data => {
            dispatchPosts({ data, type: 'UPDATE_POST' });
        });
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Card sx={{ width: '100%', position: 'relative' }}>
                {canEdit && (
                    <Stack sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}>
                        <IconButton size="small" onClick={() => swapOrder(siblings[index - 1])} disabled={!canMoveUp} aria-label="Move up">
                            <KeyboardArrowUpIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => swapOrder(siblings[index + 1])} disabled={!canMoveDown} aria-label="Move down">
                            <KeyboardArrowDownIcon fontSize="small" />
                        </IconButton>
                    </Stack>
                )}
                <CardContent>
                    <Typography variant="h5" align="center" gutterBottom>
                        {post.title}
                    </Typography>
                    <PostContent html={post.text} />
                    {canEdit && (
                        <Editor
                            dispatchPosts={dispatchPosts}
                            currentUser={currentUser}
                            post={post}
                            socket={socket}
                        />
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default PostCard;
